import { FilterType } from '@/types/filterSearch';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  all: {
    id: 'all',
    defaultMessage: 'Alla',
  },
});

export const getAllOption = (): FilterType => {
  return {
    id: messages.all.id,
    label: (
      messages.all.defaultMessage as unknown as {
        type: number;
        value: string;
      }[]
    )[0].value,
  };
};
